import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRetrieveLatestAutomationVersion from '@/hooks/api/automationVersions/useRetrieveLatestAutomationVersion.ts';
import { get_editor_composition_capabilities_url } from '@/utils/urls.ts';

export type EditorCompositionCapabilities = {
  source_version_id: string;
  scope_kind: 'local_subflow' | 'local_subflow_step';
  subflow_id: string;
  step_id?: string | null;
  supported_operations: string[];
  editable_fields: string[];
  editable_data_input_fields: string[];
  guarded_fields: string[];
  read_only_reason?: string | null;
};

const useRetrieveEditorCompositionCapabilities = (subflowId?: string, stepId?: string) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const { data: latestVersion } = useRetrieveLatestAutomationVersion();

  return useQuery({
    queryKey: ['editor-composition-capabilities', automationId, latestVersion?.id, subflowId, stepId],
    enabled: Boolean(automationId && latestVersion?.id && subflowId),
    queryFn: async () => (
      await apiClient.get<EditorCompositionCapabilities>(
        get_editor_composition_capabilities_url(automationId, subflowId, stepId),
        { suppressGlobalErrorToast: true },
      )
    ).data,
    retry: false,
    meta: { suppressGlobalErrorToast: true },
  });
};

export default useRetrieveEditorCompositionCapabilities;
